import styled from 'styled-components'

const ConfirmDescription = styled.div`
	font-size: 16px;
	color: rgb(102, 98, 96);
`

export default ConfirmDescription;